import { ADMIN_ROLES } from '@/auth/roles';
import { RequireRole } from '@/auth/RequireRole';
import type { RouteObject } from 'react-router-dom';

/**
 * Announcements: news from the gym to its members' app (holiday timings, Ramadan hours,
 * closures). Owner and admin only, like Settings (the SQL refuses everyone else too).
 */
export const announcementsRoutes: RouteObject[] = [
  {
    path: 'announcements',
    handle: { crumb: 'Announcements' },
    element: <RequireRole roles={ADMIN_ROLES} />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./AnnouncementsPage')).AnnouncementsPage }) },
    ],
  },
];
